import logo from '@/images/logo.svg';

export const WordmarkLogo: React.FC = () => (
  <img src={logo} alt="RIFF'd" className='logo logo--wordmark' style={{height:'100px',width:'auto'}} />
);

export const IconLogo: React.FC = () => (
  <img src={logo} alt="RIFF'd" className='logo logo--icon' style={{height:'100px',width:'auto'}} />
);

export const SymbolLogo: React.FC = () => (
  <img src={logo} alt="RIFF'd" className='logo logo--icon' style={{height:'100px',width:'auto'}} />
);
